import React, {useCallback} from 'react';
import {AutocompleteRenderOptionState} from "@mui/material";
import {FieldProps} from "formik";
import AutoCompleteDropdownComponent from "../auto-complete-dropdown/autoCompleteDropdownComponent";
import _ from "lodash";

interface FormikAutoCompleteDropdownProps {
    label: string;
    size?: 'small' | 'medium';
    placeholder?: string;
    fullWidth?: boolean;
    multiple?: boolean;
    id?: string;
    isDataLoading?: boolean;
    isDataLoaded?: boolean;
    isDataLoadingFailed?: boolean;
    data: any[];
    className?: string;
    disableClearable?: boolean;
    onUpdate?: (text: any) => void;
    getOptionLabel: (option: any) => string;
    openOnFocus?: boolean;
    disabled?: boolean;
    required?: boolean;
    blurOnSelect?: boolean;
    readOnly?: boolean;
    freeSolo?: boolean;
    loading?: boolean;
    url?: string;
    method?: "get" | "post" | string;
    payload?: object;
    dataListKey?: string;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    clearLocalListData?: boolean;
    noDataMessage?: string;
    loadingText?: string;
    defaultData?: any[];
    searchMode?: "clientSide" | "serverSide",
    onSelectUpdate?: Function,
    extraPayload?: object;
    renderOption?: (
        props: React.HTMLAttributes<HTMLLIElement>,
        option: any,
        state: AutocompleteRenderOptionState,
    ) => React.ReactNode;
    formikField: FieldProps;
    valueKey?: string;
}

const FormikAutoCompleteDropdown = (props: FormikAutoCompleteDropdownProps) => {
        const {
            className,
            label,
            formikField,
            required,
            disabled,
            id,
            data,
            valueKey,
            onUpdate,
            url,
            extraPayload,
            defaultData,
            renderOption,
            getOptionLabel,
            readOnly,
        } = props;
        let {
            placeholder,
            noDataMessage,
            searchMode,
            multiple,
            method,
            dataListKey,
            isDataLoading,
            isDataLoaded,
            isDataLoadingFailed,
            size,
            fullWidth,
        } = props;
        if (!placeholder) placeholder = "Select Your Option";
        if (!method) method = "get";
        if (!size) size = "medium";
        if (!searchMode) searchMode = "clientSide";
        if (!dataListKey) dataListKey = "data.docs";
        if (multiple === undefined) multiple = false;
        if (fullWidth === undefined) fullWidth = true;
        if (!noDataMessage) noDataMessage = "No data found";
        const {field, form} = formikField;
        const {name, value} = field;
        const {setFieldTouched, touched,validateField, errors, setFieldValue} = form;
        const hasError = _.get(touched, name) && !!(_.get(errors, name));

        const onValueChange = useCallback((value: any) => {
            let tempValue = value || '';
            (async () => {
                await setFieldValue(name, tempValue);
                await setFieldTouched(name);
                await validateField(name);
            })()
            if (onUpdate) {
                onUpdate(tempValue)
            }
        }, [name, onUpdate, setFieldTouched, setFieldValue,validateField]);

        const onBlur = useCallback(() => {
            setFieldTouched(name);
        }, [setFieldTouched,name]);

        return (
            <div
                className={`formik-select-dropdown-component component`}>
                <AutoCompleteDropdownComponent
                    name={name}
                    id={id}
                    readOnly={readOnly}
                    label={label}
                    required={required}
                    fullWidth={fullWidth}
                    className={className}
                    multiple={multiple}
                    data={data}
                    placeholder={placeholder}
                    disabled={disabled}
                    isDataLoading={isDataLoading}
                    isDataLoaded={isDataLoaded}
                    searchMode={searchMode}
                    getOptionLabel={getOptionLabel}
                    renderOption={renderOption}
                    url={url}
                    size={size}
                    method={method}
                    extraPayload={extraPayload}
                    isDataLoadingFailed={isDataLoadingFailed}
                    dataListKey={dataListKey}
                    defaultData={defaultData}
                    value={value}
                    hasError={hasError}
                    valueKey={valueKey}
                    errorMessage={hasError  && _.get(errors, name)}
                    noDataMessage={noDataMessage}
                    onSelectUpdate={(newValue: any) => {
                        onValueChange(newValue);
                    }}
                    onBlur={onBlur}
                />
            </div>
        );
    }
;
export default FormikAutoCompleteDropdown;
